import React from 'react';
import { motion } from 'framer-motion';
// import InteractiveMap from '../components/InteractiveMap'; // Removed
import WhatsAppConnect from '../components/whatsappConnect';
// import InquiryButton from '../components/InquiryButton'; // Removed

// Navbar component
const PageNavbar = () => (
  <nav className="fixed top-0 w-full bg-white shadow-md z-50 flex items-center justify-between px-6 h-24 overflow-hidden">
    <img src="/Hydrocawach_logo.png" alt="HydroCawach Logo" className="h-36 w-auto object-contain" />
    <h1 className="absolute left-1/2 transform -translate-x-1/2 text-blue-600 text-lg md:text-2xl font-bold text-center">
      Pre-Treatment for Biogas Using Cavitation
    </h1>
  </nav>
);

// --- DATA FOR KEY BENEFITS ---
const keyBenefits = [
  {
    icon: '⚡',
    title: 'Higher Methane Yield',
    description: 'Boosts gas output by 20–40%.'
  },
  {
    icon: '💧',
    title: 'Enhanced Hydrolysis',
    description: 'Converts complex organics into digestible substrates.'
  },
  {
    icon: '🌱',
    title: 'Chemical-Free & Energy-Efficient',
    description: 'Uses hydraulic energy, no additives.'
  },
  {
    icon: '🔄',
    title: 'Faster Digestion',
    description: 'Reduces retention time and sludge volume.'
  },
  {
    icon: '⚙️',
    title: 'Easy Integration',
    description: 'Compact, modular, and low maintenance.'
  }
];


const BiogasPreTreatment = () => (
  <div className="bg-white text-gray-800 min-h-screen relative overflow-x-hidden">
    <PageNavbar />

    <div className="pt-32 px-4"> {/* Increased top padding */}
      <div className="p-8 max-w-6xl mx-auto">

        {/* Introduction Paragraph */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-lg text-center text-gray-700 max-w-4xl mx-auto mb-16"
        >
          Hydrodynamic cavitation is an advanced, energy-efficient method to enhance biogas production
          from organic waste. The rapid formation and collapse of vapor bubbles create
          intense micro-jets that disintegrate biomass, break cell walls, and increase
          . solubility—improving anaerobic digestion efficiency.
        </motion.p>



        {/* Key Benefits Section */}
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Benefits</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 mb-20">
          {keyBenefits.map((benefit, index) => (
            <motion.div
              key={benefit.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              A className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-300"
            >
              <div className="text-5xl mb-4">{benefit.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{benefit.title}</h3>
              <p className="text-gray-700">{benefit.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Final Summary Paragraph */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          t className="bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-lg shadow-xl p-8"
          Something   >
          <p className="text-lg text-center text-blue-100 max-w-4xl mx-auto">
            Hydrocawach Cavitation Systems deliver superior biogas process intensification, enabling sustainable
            waste-to-energy conversion with higher yield, lower cost, and improved
            plant performance.
          </p>
        </motion.div>

      </div>
    </div>

    <WhatsAppConnect />
  </div>
);

export default BiogasPreTreatment;